// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Table,
//   Button,
//   Card,
//   Row,
//   Col,
//   Form,
//   Badge,
//   Modal,
// } from "react-bootstrap";
// import { membershipAPI } from "../../api/membershipPlans";
// import { gymMembersAPI } from "../../api/gymMembers";
// import Swal from "sweetalert2";
// import {
//   FaPlus,
//   FaEdit,
//   FaTrash,
//   FaEye,
//   FaFilter,
//   FaSearch,
//   FaCalendarCheck,
//   FaDollarSign,
// } from "react-icons/fa";

// const Plans = () => {
//   const navigate = useNavigate();
//   const [plans, setPlans] = useState([]);
//   const [members, setMembers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [planToDelete, setPlanToDelete] = useState(null);
//   const [filterStatus, setFilterStatus] = useState("all");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const [plansResponse, membersResponse] = await Promise.all([
//         membershipAPI.getPlans(),
//         gymMembersAPI.getMembers(),
//       ]);

//       setPlans(plansResponse.data.data || plansResponse.data);
//       setMembers(membersResponse.data.data || membersResponse.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load membership plans",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getMemberName = (memberId) => {
//     const member = members.find((m) => m.id === memberId);
//     return member
//       ? `${member.first_name} ${member.last_name}`
//       : "Unknown Member";
//   };

//   const handleDelete = async () => {
//     if (!planToDelete) return;

//     try {
//       await membershipAPI.deletePlan(planToDelete.id);

//       Swal.fire({
//         icon: "success",
//         title: "Deleted!",
//         text: "Membership plan has been deleted.",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       setPlans(plans.filter((plan) => plan.id !== planToDelete.id));
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: error.response?.data?.message || "Failed to delete plan",
//       });
//     } finally {
//       setShowDeleteModal(false);
//       setPlanToDelete(null);
//     }
//   };

//   const getFeeStatusBadge = (feeStatus) => {
//     switch (feeStatus?.toLowerCase()) {
//       case "paid":
//         return <Badge bg="success">Paid</Badge>;
//       case "pending":
//         return <Badge bg="warning">Pending</Badge>;
//       case "partial":
//         return <Badge bg="info">Partial</Badge>;
//       default:
//         return <Badge bg="secondary">Unknown</Badge>;
//     }
//   };

//   const getStatusBadge = (isActive) => {
//     return isActive ? (
//       <Badge bg="success">Active</Badge>
//     ) : (
//       <Badge bg="secondary">Inactive</Badge>
//     );
//   };

//   const filteredPlans = plans.filter((plan) => {
//     const matchesSearch =
//       getMemberName(plan.member)
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase()) ||
//       plan.id?.toString().includes(searchTerm);

//     const matchesFilter =
//       filterStatus === "all" ||
//       (filterStatus === "active" && plan.is_active) ||
//       (filterStatus === "inactive" && !plan.is_active) ||
//       (filterStatus === "pending" &&
//         plan.fee_status?.toLowerCase() === "pending") ||
//       (filterStatus === "paid" && plan.fee_status?.toLowerCase() === "paid");

//     return matchesSearch && matchesFilter;
//   });

//   const calculateRemainingDays = (expiryDate) => {
//     if (!expiryDate) return null;
//     const end = new Date(expiryDate);
//     const today = new Date();
//     const diffTime = end - today;
//     return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     try {
//       return new Date(dateString).toLocaleDateString();
//     } catch (error) {
//       return "Invalid Date";
//     }
//   };

//   const getSubscriptionTypeName = (typeId) => {
//     const types = {
//       1: "Basic",
//       2: "Premium",
//       3: "Gold",
//     };
//     return types[typeId] || `Type ${typeId}`;
//   };

//   const getSubscriptionPeriodName = (periodId) => {
//     const periods = {
//       1: "1 Month",
//       2: "3 Months",
//       3: "6 Months",
//       4: "12 Months",
//     };
//     return periods[periodId] || `${periodId} Months`;
//   };

//   return (
//     <div className="membership-plans-page">
//       <div className="page-header mb-4">
//         <div className="d-flex justify-content-between align-items-center">
//           <div>
//             <h2 className="mb-0">Membership Plans</h2>
//             <p className="text-muted mb-0">
//               Manage all membership subscriptions
//             </p>
//           </div>
//           <Button
//             variant="primary"
//             onClick={() => navigate("/membership/plans/add")}
//           >
//             <FaPlus className="me-2" /> Add New Plan
//           </Button>
//         </div>
//       </div>

//       <Card className="mb-4">
//         <Card.Body>
//           <Row className="mb-3">
//             <Col md={6}>
//               <div className="input-group">
//                 <span className="input-group-text">
//                   <FaSearch />
//                 </span>
//                 <Form.Control
//                   placeholder="Search by member name or plan ID..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             </Col>
//             <Col md={3}>
//               <Form.Select
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//               >
//                 <option value="all">All Status</option>
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//                 <option value="pending">Payment Pending</option>
//                 <option value="paid">Payment Paid</option>
//               </Form.Select>
//             </Col>
//             <Col md={3}>
//               <Button
//                 variant="outline-secondary"
//                 onClick={fetchData}
//                 className="w-100"
//               >
//                 Refresh
//               </Button>
//             </Col>
//           </Row>

//           {loading ? (
//             <div className="text-center py-5">
//               <div className="spinner-border text-primary" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           ) : (
//             <div className="table-responsive">
//               <Table hover>
//                 <thead>
//                   <tr>
//                     <th>Plan ID</th>
//                     <th>Member</th>
//                     <th>Type</th>
//                     <th>Period</th>
//                     <th>Amount</th>
//                     <th>Batch</th>
//                     <th>Start Date</th>
//                     <th>Expiry Date</th>
//                     <th>Fee Status</th>
//                     <th>Plan Status</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredPlans.length === 0 ? (
//                     <tr>
//                       <td colSpan="11" className="text-center py-4">
//                         <div className="text-muted">
//                           <FaCalendarCheck size={48} className="mb-3" />
//                           <h5>No membership plans found</h5>
//                           <p>
//                             Create your first membership plan to get started
//                           </p>
//                           <Button
//                             variant="primary"
//                             onClick={() => navigate("/membership/plans/add")}
//                           >
//                             <FaPlus className="me-2" /> Create Plan
//                           </Button>
//                         </div>
//                       </td>
//                     </tr>
//                   ) : (
//                     filteredPlans.map((plan) => {
//                       const remainingDays = calculateRemainingDays(
//                         plan.expiry_date
//                       );

//                       return (
//                         <tr key={plan.id}>
//                           <td>
//                             <div className="fw-bold">#{plan.id}</div>
//                           </td>
//                           <td>
//                             <div className="fw-medium">
//                               {getMemberName(plan.member)}
//                             </div>
//                           </td>
//                           <td>
//                             {getSubscriptionTypeName(plan.subscription_type)}
//                           </td>
//                           <td>
//                             {getSubscriptionPeriodName(
//                               plan.subscription_period
//                             )}
//                           </td>
//                           <td>
//                             <div className="d-flex align-items-center">
//                               <FaDollarSign className="me-2 text-success" />
//                               <div>
//                                 <div className="fw-bold">
//                                   ₹{plan.total_amount || plan.amount}
//                                 </div>
//                                 <small className="text-muted">
//                                   Paid: ₹{plan.paid_amount}
//                                 </small>
//                               </div>
//                             </div>
//                           </td>
//                           <td>
//                             <Badge bg="info">
//                               {plan.batch
//                                 ? plan.batch.charAt(0).toUpperCase() +
//                                   plan.batch.slice(1)
//                                 : "N/A"}
//                             </Badge>
//                           </td>
//                           <td>{formatDate(plan.plan_start_date)}</td>
//                           <td>
//                             <div>
//                               {formatDate(plan.expiry_date)}
//                               {remainingDays > 0 && remainingDays <= 30 && (
//                                 <small className="d-block text-warning">
//                                   {remainingDays} days left
//                                 </small>
//                               )}
//                               {remainingDays <= 0 && (
//                                 <small className="d-block text-danger">
//                                   Expired
//                                 </small>
//                               )}
//                             </div>
//                           </td>
//                           <td>{getFeeStatusBadge(plan.fee_status)}</td>
//                           <td>{getStatusBadge(plan.is_active)}</td>
//                           <td>
//                             <div className="d-flex gap-2">
//                               <Button
//                                 variant="outline-info"
//                                 size="sm"
//                                 onClick={() =>
//                                   navigate(`/membership/plans/${plan.id}`)
//                                 }
//                                 title="View"
//                               >
//                                 <FaEye />
//                               </Button>
//                               {/* <Button
//                                 variant="outline-warning"
//                                 size="sm"
//                                 onClick={() =>
//                                   navigate(`/membership/plans/edit/${plan.id}`)
//                                 }
//                                 title="Edit"
//                               >
//                                 <FaEdit />
//                               </Button> */}

//                               <Button
//                                 variant="outline-warning"
//                                 size="sm"
//                                 onClick={() =>
//                                   navigate(`/membership/plans/edit/${plan.id}`)
//                                 }
//                                 title="Edit"
//                               >
//                                 <FaEdit />
//                               </Button>
//                               <Button
//                                 variant="outline-danger"
//                                 size="sm"
//                                 onClick={() => {
//                                   setPlanToDelete(plan);
//                                   setShowDeleteModal(true);
//                                 }}
//                                 title="Delete"
//                               >
//                                 <FaTrash />
//                               </Button>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Stats Summary */}
//       <Row>
//         <Col md={3} sm={6}>
//           <Card className="text-center">
//             <Card.Body>
//               <h6 className="text-muted">Total Plans</h6>
//               <h3>{plans.length}</h3>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={3} sm={6}>
//           <Card className="text-center">
//             <Card.Body>
//               <h6 className="text-muted">Active Plans</h6>
//               <h3 className="text-success">
//                 {plans.filter((p) => p.is_active).length}
//               </h3>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={3} sm={6}>
//           <Card className="text-center">
//             <Card.Body>
//               <h6 className="text-muted">Total Revenue</h6>
//               <h3 className="text-primary">
//                 ₹
//                 {plans
//                   .reduce(
//                     (sum, plan) =>
//                       sum + parseFloat(plan.total_amount || plan.amount || 0),
//                     0
//                   )
//                   .toLocaleString("en-IN", { maximumFractionDigits: 0 })}
//               </h3>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={3} sm={6}>
//           <Card className="text-center">
//             <Card.Body>
//               <h6 className="text-muted">Pending Payments</h6>
//               <h3 className="text-warning">
//                 ₹
//                 {plans
//                   .reduce(
//                     (sum, plan) => sum + parseFloat(plan.pending_amount || 0),
//                     0
//                   )
//                   .toLocaleString("en-IN", { maximumFractionDigits: 0 })}
//               </h3>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Delete Confirmation Modal */}
//       <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete membership plan for{" "}
//           <strong>{planToDelete && getMemberName(planToDelete.member)}</strong>?
//           This action cannot be undone and will remove all associated payment
//           records.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default Plans;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  Button,
  Card,
  Row,
  Col,
  Form,
  Badge,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { membershipAPI } from "../../api/membershipPlans";
import { gymMembersAPI } from "../../api/gymMembers";
import { subscriptionAPI } from "../../api/subscription";
import Swal from "sweetalert2";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaSearch,
  FaCalendarCheck,
  FaMoneyBillWave,
} from "react-icons/fa";

const Plans = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [members, setMembers] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [subscriptionPeriods, setSubscriptionPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");

  // Payment form state
  const [paymentForm, setPaymentForm] = useState({
    paid_amount: "",
    payment_mode: "cash",
    remarks: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [plansResponse, membersResponse, typesResponse, periodsResponse] =
        await Promise.all([
          membershipAPI.getPlans(),
          gymMembersAPI.getMembers(),
          subscriptionAPI.getSubscriptionTypes(),
          subscriptionAPI.getSubscriptionPeriods(),
        ]);

      setPlans(plansResponse.data.data || plansResponse.data);
      setMembers(membersResponse.data.data || membersResponse.data);
      setSubscriptionTypes(typesResponse.data || []);
      setSubscriptionPeriods(periodsResponse.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load membership plans",
      });
    } finally {
      setLoading(false);
    }
  };

  const getMemberName = (memberId) => {
    const member = members.find((m) => m.id === memberId);
    return member
      ? `${member.first_name} ${member.last_name}`
      : "Unknown Member";
  };

  const getSubscriptionTypeName = (typeId) => {
    const type = subscriptionTypes.find((t) => t.id === typeId);
    return type ? type.name : `Type ${typeId}`;
  };

  const getSubscriptionPeriodName = (periodId) => {
    const period = subscriptionPeriods.find((p) => p.id === periodId);
    return period
      ? `${period.months} Month${period.months !== 1 ? "s" : ""}`
      : `${periodId} Months`;
  };

  const handleDelete = async () => {
    if (!planToDelete) return;

    try {
      await membershipAPI.deletePlan(planToDelete.id);

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Membership plan has been deleted.",
        timer: 1500,
        showConfirmButton: false,
      });

      setPlans(plans.filter((plan) => plan.id !== planToDelete.id));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to delete plan",
      });
    } finally {
      setShowDeleteModal(false);
      setPlanToDelete(null);
    }
  };

  const handleAddPayment = (plan) => {
    setSelectedPlan(plan);
    setPaymentForm({
      paid_amount: plan.pending_amount || "",
      payment_mode: "cash",
      remarks: "",
    });
    setShowPaymentModal(true);
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    if (!selectedPlan) return;

    const paymentAmount = parseFloat(paymentForm.paid_amount);
    const pendingAmount = parseFloat(selectedPlan.pending_amount);

    if (paymentAmount > pendingAmount) {
      Swal.fire({
        icon: "error",
        title: "Invalid Amount",
        text: `Payment amount cannot exceed pending amount (₹${pendingAmount})`,
      });
      return;
    }

    try {
      const paymentData = {
        plan: selectedPlan.id,
        paid_amount: paymentAmount,
        payment_mode: paymentForm.payment_mode,
        remarks: paymentForm.remarks,
      };

      await membershipAPI.createPayment(paymentData);

      Swal.fire({
        icon: "success",
        title: "Payment Added!",
        text: "Payment has been recorded successfully.",
        timer: 1500,
        showConfirmButton: false,
      });

      setShowPaymentModal(false);
      fetchData(); // Refresh data to update pending amount
    } catch (error) {
      console.error("Error adding payment:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to record payment",
      });
    }
  };

  const getFeeStatusBadge = (feeStatus) => {
    switch (feeStatus?.toLowerCase()) {
      case "paid":
        return <Badge bg="success">Paid</Badge>;
      case "pending":
        return <Badge bg="warning">Pending</Badge>;
      case "partial":
        return <Badge bg="info">Partial</Badge>;
      default:
        return <Badge bg="secondary">Unknown</Badge>;
    }
  };

  const getStatusBadge = (isActive) => {
    return isActive ? (
      <Badge bg="success">Active</Badge>
    ) : (
      <Badge bg="secondary">Inactive</Badge>
    );
  };

  const filteredPlans = plans.filter((plan) => {
    const matchesSearch =
      getMemberName(plan.member)
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      plan.id?.toString().includes(searchTerm);

    const matchesFilter =
      filterStatus === "all" ||
      (filterStatus === "active" && plan.is_active) ||
      (filterStatus === "inactive" && !plan.is_active) ||
      (filterStatus === "pending" &&
        plan.fee_status?.toLowerCase() === "pending") ||
      (filterStatus === "paid" && plan.fee_status?.toLowerCase() === "paid");

    return matchesSearch && matchesFilter;
  });

  const calculateRemainingDays = (expiryDate) => {
    if (!expiryDate) return null;
    const end = new Date(expiryDate);
    const today = new Date();
    const diffTime = end - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return "Invalid Date";
    }
  };

  const formatCurrency = (amount) => {
    return `₹${parseFloat(amount || 0).toFixed(2)}`;
  };

  const calculateStats = () => {
    const totalPending = plans.reduce(
      (sum, plan) => sum + parseFloat(plan.pending_amount || 0),
      0
    );
    const totalRevenue = plans.reduce(
      (sum, plan) => sum + parseFloat(plan.total_amount || plan.amount || 0),
      0
    );
    const totalPaid = plans.reduce(
      (sum, plan) => sum + parseFloat(plan.paid_amount || 0),
      0
    );

    return {
      totalPending,
      totalRevenue,
      totalPaid,
      totalPlans: plans.length,
      activePlans: plans.filter((p) => p.is_active).length,
    };
  };

  const stats = calculateStats();

  return (
    <div className="membership-plans-page">
      <div className="page-header mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-0">Membership Plans</h2>
            <p className="text-muted mb-0">
              Manage all membership subscriptions
            </p>
          </div>
          <Button
            variant="primary"
            onClick={() => navigate("/membership/plans/add")}
          >
            <FaPlus className="me-2" /> Add New Plan
          </Button>
        </div>
      </div>

      {/* Stats Summary */}
      <Row className="mb-4">
        <Col md={2} sm={6}>
          <Card className="text-center">
            <Card.Body>
              <h6 className="text-muted">Total Plans</h6>
              <h3>{stats.totalPlans}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} sm={6}>
          <Card className="text-center">
            <Card.Body>
              <h6 className="text-muted">Active</h6>
              <h3 className="text-success">{stats.activePlans}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6}>
          <Card className="text-center">
            <Card.Body>
              <h6 className="text-muted">Total Revenue</h6>
              <h3 className="text-primary">
                {formatCurrency(stats.totalRevenue)}
              </h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6}>
          <Card className="text-center">
            <Card.Body>
              <h6 className="text-muted">Amount Paid</h6>
              <h3 className="text-success">
                {formatCurrency(stats.totalPaid)}
              </h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} sm={6}>
          <Card className="text-center">
            <Card.Body>
              <h6 className="text-muted">Pending</h6>
              <h3 className="text-warning">
                {formatCurrency(stats.totalPending)}
              </h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="mb-4">
        <Card.Body>
          <Row className="mb-3">
            <Col md={6}>
              <div className="input-group">
                <span className="input-group-text">
                  <FaSearch />
                </span>
                <Form.Control
                  placeholder="Search by member name or plan ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </Col>

            <Col md={3}>
              <Form.Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="pending">Payment Pending</option>
                <option value="paid">Payment Paid</option>
              </Form.Select>
            </Col>
            <Col md={3}>
              <Button
                variant="outline-secondary"
                onClick={fetchData}
                className="w-100"
              >
                Refresh
              </Button>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover>
                <thead>
                  <tr>
                    <th>Plan ID</th>
                    <th>Member</th>
                    <th>Type</th>
                    <th>Period</th>
                    <th>Amount</th>
                    <th>Batch</th>
                    <th>Start Date</th>
                    <th>Expiry Date</th>
                    <th>Fee Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPlans.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center py-4">
                        <div className="text-muted">
                          <FaCalendarCheck size={48} className="mb-3" />
                          <h5>No membership plans found</h5>
                          <p>
                            Create your first membership plan to get started
                          </p>
                          <Button
                            variant="primary"
                            onClick={() => navigate("/membership/plans/add")}
                          >
                            <FaPlus className="me-2" /> Create Plan
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    filteredPlans.map((plan) => {
                      const remainingDays = calculateRemainingDays(
                        plan.expiry_date
                      );

                      return (
                        <tr key={plan.id}>
                          <td>
                            <div className="fw-bold">#{plan.id}</div>
                          </td>
                          <td>
                            <div className="fw-medium">
                              {getMemberName(plan.member)}
                            </div>
                          </td>
                          <td>
                            {getSubscriptionTypeName(plan.subscription_type)}
                          </td>
                          <td>
                            {getSubscriptionPeriodName(
                              plan.subscription_period
                            )}
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              <div className="fw-bold">
                                {formatCurrency(
                                  plan.total_amount || plan.amount
                                )}
                              </div>
                              <div className="d-flex justify-content-between">
                                <small className="text-success">
                                  Paid: {formatCurrency(plan.paid_amount)}
                                </small>
                                <small className="text-danger">
                                  Pending: {formatCurrency(plan.pending_amount)}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <Badge bg="info">
                              {plan.batch
                                ? plan.batch.charAt(0).toUpperCase() +
                                  plan.batch.slice(1)
                                : "N/A"}
                            </Badge>
                          </td>
                          <td>{formatDate(plan.plan_start_date)}</td>
                          <td>
                            <div>
                              {formatDate(plan.expiry_date)}
                              {remainingDays > 0 && remainingDays <= 30 && (
                                <small className="d-block text-warning">
                                  {remainingDays} days left
                                </small>
                              )}
                              {remainingDays <= 0 && (
                                <small className="d-block text-danger">
                                  Expired
                                </small>
                              )}
                            </div>
                          </td>
                          <td>{getFeeStatusBadge(plan.fee_status)}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="outline-primary"
                                  size="sm"
                                >
                                  Actions
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() =>
                                      navigate(`/membership/plans/${plan.id}`)
                                    }
                                  >
                                    <FaEye className="me-2" /> View Details
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() =>
                                      navigate(
                                        `/membership/plans/edit/${plan.id}`
                                      )
                                    }
                                  >
                                    <FaEdit className="me-2" /> Edit Plan
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => handleAddPayment(plan)}
                                  >
                                    <FaMoneyBillWave className="me-2" /> Add
                                    Payment
                                  </Dropdown.Item>
                                  <Dropdown.Divider />
                                  <Dropdown.Item
                                    onClick={() => {
                                      setPlanToDelete(plan);
                                      setShowDeleteModal(true);
                                    }}
                                    className="text-danger"
                                  >
                                    <FaTrash className="me-2" /> Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete membership plan for{" "}
          <strong>{planToDelete && getMemberName(planToDelete.member)}</strong>?
          This action cannot be undone and will remove all associated payment
          records.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Payment Modal */}
      <Modal show={showPaymentModal} onHide={() => setShowPaymentModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Payment</Modal.Title>
        </Modal.Header>
        {selectedPlan && (
          <Form onSubmit={handlePaymentSubmit}>
            <Modal.Body>
              <div className="alert alert-info mb-3">
                <h6 className="alert-heading">Plan Details</h6>
                <p className="mb-1">
                  <strong>Member:</strong> {getMemberName(selectedPlan.member)}
                </p>
                <p className="mb-1">
                  <strong>Total Amount:</strong>{" "}
                  {formatCurrency(
                    selectedPlan.total_amount || selectedPlan.amount
                  )}
                </p>
                <p className="mb-1">
                  <strong>Paid Amount:</strong>{" "}
                  {formatCurrency(selectedPlan.paid_amount)}
                </p>
                <p className="mb-0">
                  <strong>Pending Amount:</strong>{" "}
                  {formatCurrency(selectedPlan.pending_amount)}
                </p>
              </div>

              <Form.Group className="mb-3">
                <Form.Label>Payment Amount (₹) *</Form.Label>
                <Form.Control
                  type="number"
                  value={paymentForm.paid_amount}
                  onChange={(e) =>
                    setPaymentForm({
                      ...paymentForm,
                      paid_amount: e.target.value,
                    })
                  }
                  placeholder="Enter amount"
                  min="0"
                  max={selectedPlan.pending_amount}
                  step="0.01"
                  required
                />
                <Form.Text className="text-muted">
                  Maximum: {formatCurrency(selectedPlan.pending_amount)}
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Payment Mode *</Form.Label>
                <Form.Select
                  value={paymentForm.payment_mode}
                  onChange={(e) =>
                    setPaymentForm({
                      ...paymentForm,
                      payment_mode: e.target.value,
                    })
                  }
                  required
                >
                  <option value="cash">Cash</option>
                  <option value="upi">UPI</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Optional remarks about this payment..."
                  value={paymentForm.remarks}
                  onChange={(e) =>
                    setPaymentForm({
                      ...paymentForm,
                      remarks: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowPaymentModal(false)}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Record Payment
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal>
    </div>
  );
};

export default Plans;
